import React, { FC, memo } from 'react';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';
import { FiltersCategoryNameEnum } from '../../shared/types';

type Props = FilterData & {
  subLabel: string;
};

const PropsFilter: FC<Props> = ({ name, label, subLabel }) => {
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.assets);

  return (
    <>
      <Label $subLabel={subLabel}>{label}</Label>
      <DropdownWithChildren
        withFormik
        withSelectionsResult
        isFullWidth
        name={name}
        options={getMatchedSearchOptions(name)}
      />
    </>
  );
};

export default memo(PropsFilter);
